module.exports = __webpack_public_path__ + "ee7510eff6d0a6d5de49d64a9e386c97.pdf";